angular.module('filters').filter('htmlToText', function() {
  return function(data) {
    return angular.element(`<div>${data}</div>`).text();
  };
});
